var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGluten = function SvgGluten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gluten",
    transform: "rotate(-90,9,9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 17 16-16m-5.1274 5.1274-1.9268-1.9614c-1.592-1.62-4.1985-1.6315-5.8045-0.02551-1.606 1.606-1.5945 4.2141 0.0255 5.8053l1.9614 1.926m1.4201 1.3946 2.7471 2.6986c1.7327-1.7327 0.8919-4.3655 0-5.6054m2.971-2.813 2.7019 2.7496c-1.7327 1.7319-4.368 0.8911-5.6087 0m4.2116-1.4217c-0.6063-0.42947-1.3048-0.67465-2.0157-0.73389m-0.7331-1.9631c-1.5796-1.012-3.7064-0.82933-5.0903 0.55453-1.383 1.383-1.5665 3.5098-0.55453 5.0903m2.6937 2.7439c-0.42701-0.6055-0.67054-1.3016-0.72978-2.0108m-6.4306-10.845 7.2887 7.2896m2.3637 2.423c-0.2558 1.8035 0.3514 5.2944 4.8214 4.8213 0.7668-3.9113-2.8895-5.3643-4.8214-4.8213z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 34.043,
    strokeWidth: 1.248
  }))));
};
export default SvgGluten;